// Fixed sponsored slot (design: Popular index 2, Recommended index 3, Weekend index
// 2). The server decides WHETHER a placement exists — it arrives flagged
// `sponsored` (AP-D10, L8); the client only decides WHERE it sits, so the organic
// cards before the slot stay organic. At most one placement per rail; with no
// placement, or too few organic cards to reach the slot, the rail is purely organic.
export function placeSponsored<T extends { sponsored?: boolean }>(items: T[], slot: number, organicLimit?: number): T[] {
  const placement = items.find((b) => b.sponsored);
  const organic = items.filter((b) => !b.sponsored);
  const shown = organicLimit === undefined ? organic : organic.slice(0, organicLimit);
  if (!placement || shown.length < slot) return shown;
  return [...shown.slice(0, slot), placement, ...shown.slice(slot)];
}
